import { renderV2 } from 'base/wrapped-render-v2';
import { EmployeeTypeSelectionModal } from './employee-type-selection-modal';
import { createRoot } from 'react-dom/client';

/**
 * Renders the EmployeeTypeSelectionModal component if the EOR Remote Onboarding Integration feature flag is enabled.
 * The modal is rendered in a container element with the id 'employee-type-selection-modal-container', appended to the document body.
 */
export const openEmployeeTypeSelectionModal = () => {
    const modalContainer = document.createElement('div');
    modalContainer.id = 'employee-type-selection-modal-container';
    document.body.appendChild(modalContainer);
    const root = createRoot(modalContainer);

    const onCloseModal = () => {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        renderV2({ children: <EmployeeTypeSelectionModal isOpen={false} onClose={() => {}} />, root });
    };

    renderV2({ children: <EmployeeTypeSelectionModal isOpen={true} onClose={onCloseModal} />, root });
};
